// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__ti_6i","filesListContainer":"PosDisputesFiles_filesListContainer__38wNG","filesButton":"PosDisputesFiles_filesButton__1pajK"};